'use client';
import Menu from 'antd/es/menu';
import Input from 'antd/es/input';
import styled from 'styled-components';

import { SearchBarInputStyles } from '@shared/searchBar/styled';

export const Wrapper = styled.div`
  display: inline-flex;
  background-color: ${({ theme }) => theme.palette.white};
  position: relative;
  cursor: pointer;
  min-width: 100px;
  width: 100%;
  ${({ theme }) => theme.mediaQueries.DESKTOP} {
    width: 100%;
  }
`;

export const LabelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.2rem;
  line-height: 1.3;
  width: 100%;
  height: 100%;
  justify-content: space-evenly;
  ${({ theme }) => theme.mediaQueries.DESKTOP} {
    width: 100%;
    justify-content: center;
  }
`;

export const MainLabel = styled.label`
  font-size: 11px;
  white-space: nowrap;
  cursor: pointer;
  color: ${({ theme }) => theme.palette.darkGrey};
  ${({ theme }) => theme.mediaQueries.DESKTOP} {
    font-weight: bold;
    width: 100%;
    margin-bottom: 0;
    font-size: 12px;
    text-align: left;
  }
`;

export const Styledlabel = styled.label`
  cursor: pointer;

  font-size: 18px;
  margin-bottom: 7.5px;

  ${({ theme }) => theme.mediaQueries.PHONE} {
    width: 100%;
    margin-bottom: 0px;

    font-size: 14px;
    text-align: left;
  }
`;

export const TimeWrapper = styled.div`
  overflow: scroll;
`;

export const MenuWrapper = styled(Menu)`
  &&& {
    overflow: scroll;
    height: 220px;

    .setur-menu-light .setur-menu-item-selected {
      background-color: ${({ theme }) => theme.palette.white} !important;
    }

    .setur-menu-vertical .setur-menu-item {
      height: 40px;
      line-height: 40px;
      padding-inline: 16px;
      overflow: hidden;
      text-overflow: ellipsis;
      margin-inline: 4px;
      margin-block: 0px;
    }
  }
`;

export const DropdownButonStyled = styled.button`
  width: 100%;
  overflow: scroll;
  display: flex;

  justify-content: center;

  align-items: center;

  background-color: white;

  border-left: 1px solid;

  border-right: 1px solid;

  gap: 0.6rem;

  color: black;

  height: 80px;

  border: none;

  ${({ theme }) => theme.mediaQueries.PHONE} {
    padding: 0px 10px 0px 12px;
  }
  .setur-input:focus {
    border-color: ${({ theme }) => theme.palette.grey200} !important;
    box-shadow: ${({ theme }) => theme.palette.grey200} !important;
    border-inline-end-width: 1px;
    outline: 0;
  }
  .setur-input:hover {
    border-color: ${({ theme }) => theme.palette.grey200} !important;
    border-inline-end-width: 1px;
  }
`;

export const IconWrapper = styled.div`
  font-size: 16px;
  position: absolute;
  top: 16px;
  left: 12px;
  z-index: 1;
  pointer-events: none;
  .setur-input:focus {
    border-color: ${({ theme }) => theme.palette.grey200} !important;
    box-shadow: ${({ theme }) => theme.palette.grey200} !important;
    border-inline-end-width: 1px;
    outline: 0;
  }
  .setur-input:hover {
    border-color: ${({ theme }) => theme.palette.grey200} !important;
    border-inline-end-width: 1px;
  }
`;

export const Container = styled.div`
  display: flex;

  justify-content: center;

  align-items: center;

  cursor: pointer;

  div:last-child {
    border-right: none;
  }
`;

export const StyledInput = styled(Input)`
  &&& {
    height: 56px;
    border-radius: 4px;
    border: 1px solid ${({ theme }) => theme.palette.grey200} !important;
    padding-left: 40px;
    ${SearchBarInputStyles};
    color: ${({ theme }) => theme.palette.grey1100} !important;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;

    ::placeholder,
    ::-webkit-input-placeholder {
      color: ${({ theme }) => theme.palette.grey800} !important;
    }

    @media ${({ theme }) => `(max-width: ${theme.breakPoint.DESKTOP})`} {
      width: 100%;
    }
  }
`;

export const TimesWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: start;
`;
